<template>
  <!-- Callaction -->
  <section v-if="callAction !=''" class="ftco-intro ftco-section ftco-no-pb">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-12 text-center">
					<div class="img" :style="{ backgroundImage: 'url(' + $imgURL + callAction[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
						<div class="overlay"></div>
						<h2>{{ callAction[0].itiNome }}</h2>
						<p v-html="callAction[0].itiResumo1"></p>
						<div class="row justify-content-center">
							<div class="col-md-6">
								<p><RouterLink :to="callAction[0].itiReferencia" class="btn btn-white">{{ callAction[0].itiCampoExtra1 }}</RouterLink></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  <!-- Callaction End -->
</template>

<script>
import axios from 'axios';

export default {
  name: 'CallAction',
  data: () => ({
    callAction: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {
    //aqui busca callaction
    axios.get('/Process/InsInstitucional/institucional/19/callaction/0/x')
      .then(response => {
        this.callAction = response.data;
        //console.log('callaction')
        //console.log(this.callAction)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>